<template>
  <div class="mapBox">
    <v-comMap></v-comMap>
    <div class="control"><v-switchLayer></v-switchLayer></div>
    <div class="planLayercontrol">
      <v-planrele
        v-if="$route.path == '/index/planManage'"
        :infoData="infoData"
      ></v-planrele>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import drawLayer from "@/mixin/drawLayer.js";
export default {
  props: ["infoData"],
  mixins: [drawLayer],
  data() {
    return {};
  },

  methods: {
    ...mapActions({
      stopDrawAction: "drawMap/stopDrawAction",
      startDataDrawAction: "drawMap/startDataDrawAction",
    }),
    initMap() {
      if (!this.infoData) {
        return;
      }
      this.infoData.routes.forEach((item) => {
        this.detailLine(item.id);
      });
      this.infoData.roundareas.forEach((item) => {
        this.detailCir(item.id);
      });
      this.infoData.polygonareas.forEach((item) => {
        this.detailSq(item.id);
      });
    },
  },
  mounted() {
    this.initMap();
  },
  beforeDestroy() {
    this.stopDrawAction();
  },
};
</script>

<style lang="less" scoped>
.mapBox {
  right: -2.5%;
  left: 2.5%;
  position: relative;
  width: 95%;
  height: 100%;
}

.control {
  background-image: url("../assets/img/runcontrol/right_functionalbar_bg.png");
  padding: 15px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  list-style-type: none;
  -moz-background-size: 100% 100%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  z-index: 10000;
  top: 80px;
  right: 0;
  padding-top: 10px;
}
.planLayercontrol {
  background-color: var(--sidebar-defalut-bg);
  width: 120px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  list-style-type: none;
  -moz-background-size: 100% 100%;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  z-index: 10000;
  top: 0;
  right: 0;
  padding: 5px 0;
}

/deep/ .meteListDiv {
  top: -410px;
}
/deep/ .comMap {
  height: 100%;
}
</style>